import React, { useState, useEffect, useRef } from 'react';
//import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
//import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import Nav from 'react-bootstrap/Nav';
import Form from 'react-bootstrap/Form';

import UserDataService from '../services/user-activities';
import { withRouter } from 'react-router';

import Col from 'react-bootstrap/Col';

//import { TOTAL_TICKET_COUNT, OPEN_TICKET_COUNT } from '../features/actions/Is-Logged-Actions';

import { Redirect } from 'react-router';

import { DateTimePicker } from '@mantine/dates';

import { IconEdit, IconPencil, IconX } from "@tabler/icons-react";

import dayjs from 'dayjs';

import Container from 'react-bootstrap/Container';
import {
    Table,
    ScrollArea,
    UnstyledButton,
    Group,
    Grid,
    Text,
    Center,
    TextInput,
    Textarea,
    rem,
    keys,
    Button,
    Paper,
    Pill,
    Select,
    Switch,
    Tooltip,
    Flex,
    Modal
} from '@mantine/core';

import Navbar from './Navbar';

import { useSelector, useDispatch } from 'react-redux';
import { current } from '@reduxjs/toolkit';

import SoftwareAssetDataService from '../services/software-asset-activities';

import ProjectDataService from '../services/project-activities';

import { useHistory } from 'react-router-dom';

//import { LOGOUT } from '../features/actions/Is-Logged-Actions';

export default function AddProject({LOGOUT, onLogout}) {

    const history = useHistory();

    const loggedStatus = useSelector(state => state.logged);
    
    const [customerId, setCustomerId] = useState(0);
    const [customerName, setCustomerName] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [currentTask, setCurrentTask] = useState("");
    const [nextSteps, setNextSteps] = useState("");
    //const [assignedToId, setAssignedToId] = useState(0);
    const [assignedToName, setAssignedToName] = useState("");
    const [status, setStatus] = useState("");
    const [lastUpdate, setLastUpdate] = useState("");
    const [teamMember, setTeamMember] = useState("");

    const [customers, setCustomers] = useState(null);
    //const [employees, setEmployees] = useState(null);
    const [teamMemberList, setTeamMemberList] = useState([]);


    const [canSeeMissingCustomerError, setCanSeeMissingCustomerError] = useState(false);



    useEffect(() => {
        const loadData = async () => {
            //console.log("Value for loggedStatus: ", loggedStatus);
            SoftwareAssetDataService.getCustomers(loggedStatus.primary_tenant_id).then(response => {
                console.log(response);
                setCustomers(response.data.results);
            });
        }

        loadData();
    }, []);


    function addTeamMember() {
        let currentList = teamMemberList;

        // add the current value from the teamMember state variable
        currentList.push(teamMember);

        // set the team member list to the original + the latest one entered
        setTeamMemberList(currentList);

        // reset team member back to ""
        setTeamMember("");
    }

    function removeTeamMember(nameToRemove) {
        const updatedTeamList = teamMemberList.filter(item => item.toLowerCase() !== nameToRemove.toLowerCase());

        setTeamMemberList(updatedTeamList);
    }


    function convertDateToMySQL(date) {
        try {
            const mysqlFormat = dayjs(date).format('YYYY-MM-DD HH:mm:ss');
            return mysqlFormat;
        }

        catch {
            return "";
        }
    }


    async function submitForm() {

        if(customerId && customerId !== 0) {
            setCanSeeMissingCustomerError(false);

            console.log("Going to submit form with the following details");

            console.log("Managing tenant id: ", loggedStatus.primary_tenant_id);

            console.log("Customer id: ", customerId);
            console.log("Title: ", title);
            console.log("Description: ", description);
            console.log("Current Task: ", currentTask);
            console.log("Next Steps: ", nextSteps);
            
            console.log("Assigned To: ", assignedToName);
            console.log("Status: ", status);
            console.log("Last Update: ", lastUpdate);

            console.log("Last Update - converted to MySQL: ", convertDateToMySQL(lastUpdate));
            
            console.log("Team Member List: ", teamMemberList);

            
            let data = {
                managingTenantId: loggedStatus.primary_tenant_id,
                customerId: customerId && customerId !== "" ? parseInt(customerId) : 0,
                title: title,
                description: description,
                currentTask: currentTask,
                nextSteps: nextSteps,
                assignedTo: assignedToName,
                status: status,
                lastUpdate: lastUpdate ? convertDateToMySQL(lastUpdate) : "",
                teamMemberList: teamMemberList
            }

            console.log("Submission as object: ", data);


            ProjectDataService.addProject(data).then(response => {

                console.log("Response from add project: ", response);

                // navigate back to the projects list page
                history.push(`/projects`);

            });
        }

        else {
            console.log("Must select a customer");
            setCanSeeMissingCustomerError(true);
        }

    }

    

    if (!loggedStatus.loggedIn) {
            return (
                <Redirect to='/' />
            );
    }

    return (
        <>
            <Navbar pageTitle={"Add a Project"} />
            <div className="container mt-3" style={{ paddingTop: "15px" }}></div>
            <Container fluid pt="20px" >
                <Paper withBorder p="md" radius="md" w="100%" mb="sm" display="inline-block">
                    <Form>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Select 
                                    label="Customer"
                                    placeholder="Pick value"
                                    data={
                                        customers && customers.map((customer) => (
                                            {value: customer.id.toString(), label: customer.name}
                                        ))
                                    }
                                    value={customerId ? customerId : null}
                                    onChange={setCustomerId}
                                    required
                                    allowDeselect={false}
                                />
                            </Form.Group>
                            
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <TextInput 
                                    label="Title"
                                    placeholder='Input a value'
                                    value={title}
                                    onChange={(event) => setTitle(event.currentTarget.value)}
                                />
                            </Form.Group>
                            
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Textarea 
                                    label="Description"
                                    placeholder='Input a value'
                                    value={description}
                                    onChange={(event) => setDescription(event.currentTarget.value)}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <TextInput 
                                    label="Current Task"
                                    placeholder='Input a value'
                                    value={currentTask}
                                    onChange={(event) => setCurrentTask(event.currentTarget.value)}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <TextInput 
                                    label="Next Steps"
                                    placeholder='Input a value'
                                    value={nextSteps}
                                    onChange={(event) => setNextSteps(event.currentTarget.value)}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <TextInput 
                                    label="Currently Assigned To"
                                    placeholder='Input a value'
                                    value={assignedToName}
                                    onChange={(event) => setAssignedToName(event.currentTarget.value)}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Select 
                                    label="Status"
                                    data={['In Progress', 'On Hold', 'Complete']}
                                    value={status}
                                    onChange={setStatus}
                                />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <DateTimePicker 
                                    label="Last Updated"
                                    placeholder="Pick date and time"
                                    valueFormat={"MM / DD / YYYY hh:mm A"}
                                    value={lastUpdate}
                                    onChange={setLastUpdate}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <span style={{ display: "inline-block", width: "50%" }}>
                                    <TextInput 
                                        label="Add Project Team Member"
                                        placeholder='Input a value'
                                        value={teamMember}
                                        onChange={(event) => setTeamMember(event.currentTarget.value)}
                                    />
                                </span>
                                <span style={{ display: "inline-block", paddingLeft: "10px", cursor: "pointer" }}>
                                    <Button onClick={() => addTeamMember()}>Add</Button>
                                </span>
                            </Form.Group>
                        </Form.Row>
                    </Form>
                    {teamMemberList && teamMemberList.map((name, index) => (
                        <div key={`member-${index}`}>
                            <span style={{paddingRight: "15px"}}><IconX color="red" style={{cursor: "pointer"}} onClick={() => removeTeamMember(name)}/></span><Text size="sm" span>{name}</Text>
                        </div>
                    ))}

                    {canSeeMissingCustomerError ?
                        <Text c="red" ta="center">Error: A customer selection is required to create a project.</Text>
                        :
                        undefined
                    }

                    <div style={{textAlign: 'center', marginTop: "50px"}}>
                        <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => history.push('/projects')} className="gothamNarrowFont">Cancel</Button></span>
                        <span><Button id="newDepartmentFormOkButton" onClick={() => submitForm()} className="gothamNarrowFont">Submit</Button></span>
                    </div>
                </Paper>
            </Container>
        </>
    );
}